// import { Link } from 'react-router-dom';
// import React, { useEffect, useState } from "react";
// import '../css/home.css';
// import {
//   CheckCircle,
//   Package, Users, Clock,
// } from 'lucide-react';
// import { useInView } from 'react-intersection-observer';
// import CountUp from "react-countup";
// import analysisImage from '../assests/images/analysis.jpg';
// import NetworkIcon from '../assests/images/erp-infographic.jpg';
// import ChartBarIcon from '../assests/images/data.jpg';
// import LightbulbIcon from '../assests/images/Strategic.jpg';
// import Code12 from "../assests/images/Code12.jpg";
// import erpnextIcon from '../assests/images/Erpnext-icon.jpg';
// import dynamicsNavIcon from '../assests/images/microsoft_dynamics_icon.png';
// import azureIcon from '../assests/images/microsoft_azure_icon.png';
// import powerBiIcon from '../assests/images/powerBI_icon.png';
// import office365Icon from '../assests/images/office365_icon.png';
// import businessCentralIcon from '../assests/images/business-central-icon.png';
// import WhyChooseUs from "./WhyChooseUs";
// import ServiceVisual from "../assests/images/carousel-1.jpg";
// const HomePage = () => {
//   const services = [
//     {
//       icon: NetworkIcon,
//       title: "Integrated ERP Solutions",
//       text: "Our integrated ERP solutions are designed to streamline your business operations, from finance and human resources to supply chain management and customer relationship management. With our expertise in Microsoft ERP systems, we offer tailored solutions that meet your specific"
//     },
//     {
//       icon: ChartBarIcon,
//       title: "Data Analytics",
//       text: "Harness the power of data with our advanced analytics and digital transformation services. We help you unlock actionable insights from your data assets, enabling data-driven decision-making and innovation. Our data analytics solutions encompass data collection, cleansing, modeling, and visualization"
//     },
//     {
//       icon: LightbulbIcon,
//       title: "Strategic Business Consultancy",
//       text: "Our strategic business consultancy services are aimed at helping you navigate the complexities of the business landscape and make informed decisions that drive growth and profitability. Leveraging our expertise in project management, business analysis, and functional consultancy, we"
//     },
//   ];

//   const [statsVisible, setStatsVisible] = useState(false);
//   const { ref: statsRef, inView: statsInView } = useInView({ threshold: 0.3, triggerOnce: true });
//   useEffect(() => {
//     if (statsInView) setStatsVisible(true);
//   }, [statsInView]);

//   const products = [
//     {
//       icon: '💼',
//       title: 'Microsoft Dynamics 365 Business Central',
//       background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174) 100%)',
//       description: 'An all-in-one platform offering integrated tools to efficiently manage finance, human resources, procurement, inventory, and daily operations—all in one centralized system.',
//     },
//     {
//       icon: '📊',
//       title: 'Analytics Dashboard',
//       background: 'linear-gradient(135deg,rgb(201, 234, 241) 0%,rgb(132, 172, 180) 100%)',
//       description: 'Interactive, real-time dashboards powered by Power BI and Azure, delivering deep insights, trends, and performance metrics to guide strategic decisions.',
//     },
//     {
//       icon: '☁️',
//       background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174) 100%)',
//       title: 'Cloud Solutions',
//       description: 'Effortlessly connect your operations to cloud services like Microsoft Azure and Office 365 to enable secure data access, remote collaboration, and scalability.',
//     },
//     {
//       icon: '🧩',
//       title: 'ERPNext',
//       background: 'linear-gradient(135deg,rgb(201, 234, 241) 0%,rgb(132, 172, 180) 100%)',
//       description: 'A highly customizable, open-source ERP platform offering end-to-end modules for accounting, sales, CRM, HR, inventory, and more—ideal for businesses of all sizes.',
//     },
//     {
//       icon: '🛠️',
//       title: 'Custom Software Solutions',
//       background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174) 100%)',
//       description: 'Designed specifically for your business needs, these custom-built ERP modules enhance productivity by automating workflows and bridging process gaps.',
//     },
//     {
//       icon: '🛒',
//       title: 'POS',
//       background: 'linear-gradient(135deg,rgb(201, 234, 241) 0%,rgb(132, 172, 180) 100%)',
//       description: 'A fast, user-friendly Point of Sale system that syncs with your ERP in real time to manage sales, inventory, customer data, and transactions across multiple outlets.',
//     },
//   ];

//   const partners = [
//     { icon: erpnextIcon, name: 'ERPNext' },
//     { icon: dynamicsNavIcon, name: 'Dynamics NAV' },
//     { icon: businessCentralIcon, name: 'Business Central' },
//     { icon: azureIcon, name: 'Azure' },
//     { icon: powerBiIcon, name: 'Power BI' },
//     { icon: office365Icon, name: 'Office 365' },
//   ];

//   return (
//     <div style={{ overflow: 'hidden' }}>
//       {/* Hero Section (keep existing) */}
//       {/* Hero Section */}
//       <section className="first-section">
//         <div className="section-image">
//           <img src={Code12} alt="Business Solutions Overview" />
//         </div>

//         <div className="section-content">
//           <div className="content-wrapper">
//             <h1>
//               Empowering Your Business with Tailored Digital Solutions
//             </h1>
//             <p>
//               We build smart, scalable systems—from ERP and custom software to document management and analytics—designed to streamline your operations and accelerate growth.
//             </p>
//             <Link to="/contact" className="discover-more">
//               <span className="discover-text">Discover more</span>
//             </Link>
//           </div>
//         </div>
//       </section>

//       {/* Enhanced Services Section */}
//       <section
//         style={{
//           padding: '10rem 0 0',
//           background: 'linear-gradient(160deg, #f8fafb 0%, #e2e8f0 100%)',
//           position: 'relative',
//         }}
//       >
//         <div
//           style={{
//             maxWidth: '80%',
//             margin: '0 auto',
//             position: 'relative',
//             zIndex: 2,
//           }}
//         >
//           <div className="row g-4" style={{ marginBottom: 0 }}>
//             {services.slice(0, 6).map((service, index) => (
//               <div key={index} className="col-lg-4 col-md-6" style={{ marginBottom: '0' }}>
//                 <div
//                   className="service-card move-up"
//                   style={{
//                     transform: 'translateY(-50%)',
//                     marginBottom: '-11rem',
//                   }}
//                 >
//                   <div className="service-img-wrapper">
//                     <img src={service.icon} alt={service.title} className="service-img" />
//                   </div>
//                   <div
//                     className="service-content"
//                     style={{
//                       padding: '1.5rem',
//                       backgroundColor: '#fff',
//                     }}
//                   >
//                     <h5 style={{ marginBottom: '0.5rem' }}>{service.title}</h5>
//                     <p className="text-muted">{service.text}</p>
//                     <a
//                       href="/services"
//                       style={{
//                         marginTop: '0.75rem',
//                         display: 'inline-block',
//                         color: '#FFA916',
//                         fontWeight: '500',
//                         textDecoration: 'none',
//                       }}
//                     >
//                       → View Details
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       <section
//         style={{
//           position: 'relative',
//           display: 'flex',
//           padding: '4rem 2rem',
//           alignItems: 'flex-start',
//           justifyContent: 'space-between',
//           gap: '2rem',
//           backgroundImage: `url(${ServiceVisual})`,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           backgroundRepeat: 'no-repeat',
//           color: 'white',
//           overflow: 'hidden',
//         }}
//       >
//         {/* Overlay with backgroundColor and blur */}
//         <div
//           style={{
//             content: '""',
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             backgroundColor: '#024A59',
//             opacity: 0.85,
//             backdropFilter: 'blur(6px)', // blur effect
//             WebkitBackdropFilter: 'blur(6px)',
//             zIndex: 0,
//           }}
//         />

//         {/* Left Column */}
//         <div style={{ flex: 1, position: 'relative', zIndex: 1 }}>
//           <h2 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#FFA916' }}>
//             Company Overview
//           </h2>
//           <h3 style={{ fontSize: '1.5rem', fontWeight: '500', color: '#e2e8f0' }}>
//             Innovating Business Excellence
//           </h3>

//         </div>

//         {/* Right Column */}
//         <div style={{ flex: 2, position: 'relative', zIndex: 1 }}>
//           <p style={{ fontSize: '1.1rem', color: '#f8fafc', lineHeight: 1.7 }}>
//             Statify Solutions Limited is a forward-thinking software company committed to
//             innovation and excellence. Beyond ERP, we deliver a wide range of tailored
//             digital solutions that drive transformation and growth for businesses globally.
//             With a customer-first approach, we strive to exceed expectations and create
//             lasting impact across industries.
//           </p>
//           <div
//             style={{
//               marginTop: '1rem',
//               display: 'flex',
//               justifyContent: 'flex-end',
//             }}
//           >
//             <a
//               href="/about"
//               style={{
//                 color: '#FFA916',
//                 fontWeight: '500',
//                 textDecoration: 'none',
//               }}
//             >
//               → More About Us
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Products Section */}
//       <section className="products-section">
//         <h2 style={{ fontSize: '3rem', fontWeight: '700', color: '#024A59', marginBottom: '1rem' }}>
//           <span style={{ color: '#024A59' }}>Our Products</span>
//         </h2>
//         <h5 style={{ textAlign: 'center', color: 'black', marginBottom: '2rem' }}>
//           Empowering Enterprises Through Technology.
//         </h5>
//         <div className="products-grid">
//           {products.map((product, index) => (
//             <div
//               className="product-card"
//               key={index}
//               style={{
//                 background: product.background, // Apply the background gradient dynamically
//                 borderRadius: '15px',
//                 padding: '2rem',
//                 boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
//                 transition: 'all 0.3s ease',
//               }}
//             >
//               <div className="product-icon" style={{ fontSize: '40px' }}>
//                 {product.icon} {/* Display the icon */}
//               </div>
//               <h3 className="product-title">{product.title}</h3>
//               <p className="product-description">{product.description}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Stats Section */}
//       <section >
//         <div
//           ref={statsRef}
//           style={{
//             backgroundImage: `url(${analysisImage})`,
//             backgroundSize: 'cover',
//             backgroundPosition: 'center',
//             padding: '2rem 1rem',
//             color: 'white',
//             position: 'relative',
//           }}
//         >
//           {/* Optional overlay for better readability */}
//           <div style={{
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: 'rgba(2, 74, 89, 0.85)', // optional dark overlay
//             zIndex: 0,
//           }} />

//           <h5 style={{
//             textAlign: 'center',
//             color: 'white',
//             marginBottom: '2rem',
//             position: 'relative',
//             zIndex: 1
//           }}>
//             Empowering your business to reach new heights.
//           </h5>

//           <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
//             <div style={{
//               display: 'grid',
//               gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
//               gap: '2rem',
//               textAlign: 'center'
//             }}>
//               {[
//                 { number: 13, title: "Products", icon: <Package size={40} color="#FFA916" /> },
//                 { number: 19, title: "Services", icon: <CheckCircle size={40} color="#FFA916" /> },
//                 { number: 31, title: "Satisfied Clients", icon: <Users size={40} color="#FFA916" /> },
//                 { number: 8, title: "Ongoing Projects", icon: <Clock size={40} color="#FFA916" /> }
//               ].map((stat, index) => (
//                 <div key={index} style={{
//                   opacity: statsVisible ? 1 : 0,
//                   transform: statsVisible ? 'translateY(0)' : 'translateY(30px)',
//                   transition: `all 0.6s ease ${index * 0.2}s`,
//                   background: 'rgba(255, 255, 255, 0.15)', // semi-transparent white
//                   borderRadius: '16px',
//                   padding: '2rem',
//                   backdropFilter: 'blur(6px)', // optional glass effect
//                 }}>
//                   <div style={{
//                     background: 'rgba(255, 169, 22, 0.1)',
//                     width: '70px',
//                     height: '70px',
//                     borderRadius: '50%',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     margin: '0 auto 1rem'
//                   }}>
//                     {stat.icon}
//                   </div>
//                   <h2 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#FFA916', marginBottom: '0.5rem' }}>
//                     {statsVisible ? <CountUp end={stat.number} duration={2.5} /> : stat.number}
//                     {stat.title === 'Products' && '+'}
//                     {['Services'].includes(stat.title) && '+'}
//                     {['Satisfied Clients'].includes(stat.title) && '+'}
//                   </h2>
//                   <p style={{ fontSize: '1.1rem', margin: 0 }}>{stat.title}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>
//       <section className="partners-section">
//         <h2 className="partners-title">Our Partners/Technologies</h2>
//         <div className="partners-row">
//           {partners.map((partner, index) => (
//             <div key={index} className="partner-card">
//               <img
//                 src={partner.icon}
//                 alt={partner.name}
//                 className="partner-icon"
//               />
//               <p className="partner-name">{partner.name}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       <WhyChooseUs />

//       <style jsx global>{`
//         @keyframes fade-in {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }

//         @keyframes slide-up {
//           from { transform: translateY(50px); opacity: 0; }
//           to { transform: translateY(0); opacity: 1; }
//         }

//         @keyframes card-pop {
//           from { transform: scale(0.8) rotateZ(-5deg); opacity: 0; }
//           to { transform: scale(1) rotateZ(0deg); opacity: 1; }
//         }

//         .animate-fade-in {
//           animation: fade-in 0.8s ease-out forwards;
//         }

//         .animate-slide-up {
//           animation: slide-up 0.6s cubic-bezier(0.22, 1, 0.36, 1) forwards;
//         }

//         .animate-card-pop {
//           animation: card-pop 0.6s cubic-bezier(0.18, 0.89, 0.32, 1.28) forwards;
//         }

//         @media (prefers-reduced-motion: reduce) {
//           .animate-fade-in,
//           .animate-slide-up,
//           .animate-card-pop {
//             animation: none;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default HomePage;



// First typing effect 

// import { Link } from 'react-router-dom';
// import React, { useEffect, useState } from "react";
// import '../css/home.css';
// import {
//   CheckCircle,
//   Package, Users, Clock,
// } from 'lucide-react';
// import { useInView } from 'react-intersection-observer';
// import CountUp from "react-countup";
// import Typewriter from 'typewriter-effect';
// import Marquee from "react-fast-marquee";
// import analysisImage from '../assests/images/analysis.jpg';
// import NetworkIcon from '../assests/images/erp-infographic.jpg';
// import ChartBarIcon from '../assests/images/data.jpg';
// import LightbulbIcon from '../assests/images/Strategic.jpg';
// import Code12 from "../assests/images/Code12.jpg";
// import erpnextIcon from '../assests/images/Erpnext-icon.jpg';
// import dynamicsNavIcon from '../assests/images/microsoft_dynamics_icon.png';
// import azureIcon from '../assests/images/microsoft_azure_icon.png';
// import powerBiIcon from '../assests/images/powerBI_icon.png';
// import office365Icon from '../assests/images/office365_icon.png';
// import businessCentralIcon from '../assests/images/business-central-icon.png';
// import WhyChooseUs from "./WhyChooseUs";
// import ServiceVisual from "../assests/images/carousel-1.jpg";

// const HomePage = () => {
//   // State for discover more button
//   const [showDiscoverMore, setShowDiscoverMore] = useState(false);
  
//   const services = [
//     {
//       icon: NetworkIcon,
//       title: "Integrated ERP Solutions",
//       text: "Our integrated ERP solutions are designed to streamline your business operations, from finance and human resources to supply chain management and customer relationship management. With our expertise in Microsoft ERP systems, we offer tailored solutions that meet your specific"
//     },
//     {
//       icon: ChartBarIcon,
//       title: "Data Analytics",
//       text: "Harness the power of data with our advanced analytics and digital transformation services. We help you unlock actionable insights from your data assets, enabling data-driven decision-making and innovation. Our data analytics solutions encompass data collection, cleansing, modeling, and visualization"
//     },
//     {
//       icon: LightbulbIcon,
//       title: "Strategic Business Consultancy",
//       text: "Our strategic business consultancy services are aimed at helping you navigate the complexities of the business landscape and make informed decisions that drive growth and profitability. Leveraging our expertise in project management, business analysis, and functional consultancy, we"
//     },
//   ];

//   const [statsVisible, setStatsVisible] = useState(false);
//   const { ref: statsRef, inView: statsInView } = useInView({ threshold: 0.3, triggerOnce: true });
//   useEffect(() => {
//     if (statsInView) setStatsVisible(true);
//   }, [statsInView]);

//   const products = [
//     {
//       icon: '💼',
//       title: 'Microsoft Dynamics 365 Business Central',
//       background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174) 100%)',
//       description: 'An all-in-one platform offering integrated tools to efficiently manage finance, human resources, procurement, inventory, and daily operations—all in one centralized system.',
//     },
//     {
//       icon: '📊',
//       title: 'Analytics Dashboard',
//       background: 'linear-gradient(135deg,rgb(201, 234, 241) 0%,rgb(132, 172, 180) 100%)',
//       description: 'Interactive, real-time dashboards powered by Power BI and Azure, delivering deep insights, trends, and performance metrics to guide strategic decisions.',
//     },
//     {
//       icon: '☁️',
//       background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174) 100%)',
//       title: 'Cloud Solutions',
//       description: 'Effortlessly connect your operations to cloud services like Microsoft Azure and Office 365 to enable secure data access, remote collaboration, and scalability.',
//     },
//     {
//       icon: '🧩',
//       title: 'ERPNext',
//       background: 'linear-gradient(135deg,rgb(201, 234, 241) 0%,rgb(132, 172, 180) 100%)',
//       description: 'A highly customizable, open-source ERP platform offering end-to-end modules for accounting, sales, CRM, HR, inventory, and more—ideal for businesses of all sizes.',
//     },
//     {
//       icon: '🛠️',
//       title: 'Custom Software Solutions',
//       background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174) 100%)',
//       description: 'Designed specifically for your business needs, these custom-built ERP modules enhance productivity by automating workflows and bridging process gaps.',
//     },
//     {
//       icon: '🛒',
//       title: 'POS',
//       background: 'linear-gradient(135deg,rgb(201, 234, 241) 0%,rgb(132, 172, 180) 100%)',
//       description: 'A fast, user-friendly Point of Sale system that syncs with your ERP in real time to manage sales, inventory, customer data, and transactions across multiple outlets.',
//     },
//   ];

//   const partners = [
//     { icon: erpnextIcon, name: 'ERPNext' },
//     { icon: dynamicsNavIcon, name: 'Dynamics NAV' },
//     { icon: businessCentralIcon, name: 'Business Central' },
//     { icon: azureIcon, name: 'Azure' },
//     { icon: powerBiIcon, name: 'Power BI' },
//     { icon: office365Icon, name: 'Office 365' },
//   ];

//   // Show discover more button after 1.5 seconds
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowDiscoverMore(true);
//     }, 1500);
//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <div style={{ overflow: 'hidden' }}>
//       {/* Hero Section - Fixed with image on left and content on right */}
//       <section className="first-section">
//         <div className="section-image">
//           <img src={Code12} alt="Business Solutions Overview" />
//         </div>

//         <div className="section-content">
//           <div className="content-wrapper">
//             {/* Continuous Typing Effect for h1 */}
//             <h1 style={{ minHeight: '120px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
//               <Typewriter
//                 options={{
//                   strings: ['Empowering Your Business with Tailored Digital Solutions'],
//                   autoStart: true,
//                   loop: true,
//                   delay: 50,
//                   deleteSpeed: 30,
//                   pauseFor: 2000,
//                   cursor: '|',
//                 }}
//               />
//             </h1>
            
//             <p>
//               We build smart, scalable systems—from ERP and custom software to document management and analytics—designed to streamline your operations and accelerate growth.
//             </p>
            
//             {/* Discover More Link */}
//             <Link 
//               to="/contact" 
//               className="discover-more"
//               style={{ 
//                 opacity: showDiscoverMore ? 1 : 0,
//                 transform: showDiscoverMore ? 'translateY(0)' : 'translateY(10px)',
//                 transition: 'opacity 0.8s ease, transform 0.8s ease',
//                 display: 'inline-block',
//                 marginTop: '1.5rem'
//               }}
//             >
//               <span className="discover-text">
//                 Discover more
//               </span>
//             </Link>
//           </div>
//         </div>
//       </section>

//       {/* Enhanced Services Section */}
//       <section
//         style={{
//           padding: '10rem 0 0',
//           background: 'linear-gradient(160deg, #f8fafb 0%, #e2e8f0 100%)',
//           position: 'relative',
//         }}
//       >
//         <div
//           style={{
//             maxWidth: '80%',
//             margin: '0 auto',
//             position: 'relative',
//             zIndex: 2,
//           }}
//         >
//           <div className="row g-4" style={{ marginBottom: 0 }}>
//             {services.slice(0, 6).map((service, index) => (
//               <div key={index} className="col-lg-4 col-md-6" style={{ marginBottom: '0' }}>
//                 <div
//                   className="service-card move-up"
//                   style={{
//                     transform: 'translateY(-50%)',
//                     marginBottom: '-11rem',
//                   }}
//                 >
//                   <div className="service-img-wrapper">
//                     <img src={service.icon} alt={service.title} className="service-img" />
//                   </div>
//                   <div
//                     className="service-content"
//                     style={{
//                       padding: '1.5rem',
//                       backgroundColor: '#fff',
//                     }}
//                   >
//                     <h5 style={{ marginBottom: '0.5rem' }}>{service.title}</h5>
//                     <p className="text-muted">{service.text}</p>
//                     <a
//                       href="/services"
//                       style={{
//                         marginTop: '0.75rem',
//                         display: 'inline-block',
//                         color: '#FFA916',
//                         fontWeight: '500',
//                         textDecoration: 'none',
//                       }}
//                     >
//                       → View Details
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       <section
//         style={{
//           position: 'relative',
//           display: 'flex',
//           padding: '4rem 2rem',
//           alignItems: 'flex-start',
//           justifyContent: 'space-between',
//           gap: '2rem',
//           backgroundImage: `url(${ServiceVisual})`,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           backgroundRepeat: 'no-repeat',
//           color: 'white',
//           overflow: 'hidden',
//         }}
//       >
//         {/* Overlay with backgroundColor and blur */}
//         <div
//           style={{
//             content: '""',
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             backgroundColor: '#024A59',
//             opacity: 0.85,
//             backdropFilter: 'blur(6px)',
//             WebkitBackdropFilter: 'blur(6px)',
//             zIndex: 0,
//           }}
//         />

//         {/* Left Column */}
//         <div style={{ flex: 1, position: 'relative', zIndex: 1 }}>
//           <h2 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#FFA916' }}>
//             Company Overview
//           </h2>
//           <h3 style={{ fontSize: '1.5rem', fontWeight: '500', color: '#e2e8f0' }}>
//             Innovating Business Excellence
//           </h3>
//         </div>

//         {/* Right Column */}
//         <div style={{ flex: 2, position: 'relative', zIndex: 1 }}>
//           <p style={{ fontSize: '1.1rem', color: '#f8fafc', lineHeight: 1.7 }}>
//             Statify Solutions Limited is a forward-thinking software company committed to
//             innovation and excellence. Beyond ERP, we deliver a wide range of tailored
//             digital solutions that drive transformation and growth for businesses globally.
//             With a customer-first approach, we strive to exceed expectations and create
//             lasting impact across industries.
//           </p>
//           <div
//             style={{
//               marginTop: '1rem',
//               display: 'flex',
//               justifyContent: 'flex-end',
//             }}
//           >
//             <a
//               href="/about"
//               style={{
//                 color: '#FFA916',
//                 fontWeight: '500',
//                 textDecoration: 'none',
//               }}
//             >
//               → More About Us
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Products Section */}
//       <section className="products-section">
//         <h2 style={{ fontSize: '3rem', fontWeight: '700', color: '#024A59', marginBottom: '1rem' }}>
//           <span style={{ color: '#024A59' }}>Our Products</span>
//         </h2>
//         <h5 style={{ textAlign: 'center', color: 'black', marginBottom: '2rem' }}>
//           Empowering Enterprises Through Technology.
//         </h5>
//         <div className="products-grid">
//           {products.map((product, index) => (
//             <div
//               className="product-card"
//               key={index}
//               style={{
//                 background: product.background,
//                 borderRadius: '15px',
//                 padding: '2rem',
//                 boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
//                 transition: 'all 0.3s ease',
//               }}
//             >
//               <div className="product-icon" style={{ fontSize: '40px' }}>
//                 {product.icon}
//               </div>
//               <h3 className="product-title">{product.title}</h3>
//               <p className="product-description">{product.description}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Stats Section */}
//       <section >
//         <div
//           ref={statsRef}
//           style={{
//             backgroundImage: `url(${analysisImage})`,
//             backgroundSize: 'cover',
//             backgroundPosition: 'center',
//             padding: '2rem 1rem',
//             color: 'white',
//             position: 'relative',
//           }}
//         >
//           {/* Optional overlay for better readability */}
//           <div style={{
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: 'rgba(2, 74, 89, 0.85)',
//             zIndex: 0,
//           }} />

//           <h5 style={{
//             textAlign: 'center',
//             color: 'white',
//             marginBottom: '2rem',
//             position: 'relative',
//             zIndex: 1
//           }}>
//             Empowering your business to reach new heights.
//           </h5>

//           <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
//             <div style={{
//               display: 'grid',
//               gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
//               gap: '2rem',
//               textAlign: 'center'
//             }}>
//               {[
//                 { number: 13, title: "Products", icon: <Package size={40} color="#FFA916" /> },
//                 { number: 19, title: "Services", icon: <CheckCircle size={40} color="#FFA916" /> },
//                 { number: 31, title: "Satisfied Clients", icon: <Users size={40} color="#FFA916" /> },
//                 { number: 8, title: "Ongoing Projects", icon: <Clock size={40} color="#FFA916" /> }
//               ].map((stat, index) => (
//                 <div key={index} style={{
//                   opacity: statsVisible ? 1 : 0,
//                   transform: statsVisible ? 'translateY(0)' : 'translateY(30px)',
//                   transition: `all 0.6s ease ${index * 0.2}s`,
//                   background: 'rgba(255, 255, 255, 0.15)',
//                   borderRadius: '16px',
//                   padding: '2rem',
//                   backdropFilter: 'blur(6px)',
//                 }}>
//                   <div style={{
//                     background: 'rgba(255, 169, 22, 0.1)',
//                     width: '70px',
//                     height: '70px',
//                     borderRadius: '50%',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     margin: '0 auto 1rem'
//                   }}>
//                     {stat.icon}
//                   </div>
//                   <h2 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#FFA916', marginBottom: '0.5rem' }}>
//                     {statsVisible ? <CountUp end={stat.number} duration={2.5} /> : stat.number}
//                     {stat.title === 'Products' && '+'}
//                     {['Services'].includes(stat.title) && '+'}
//                     {['Satisfied Clients'].includes(stat.title) && '+'}
//                   </h2>
//                   <p style={{ fontSize: '1.1rem', margin: 0 }}>{stat.title}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Partners Section with Marquee */}
//       <section className="partners-section">
//         <h2 className="partners-title">Our Partners/Technologies</h2>
        
//         <div className="marquee-wrapper">
//           <Marquee 
//             speed={40} 
//             gradient={true}
//             gradientColor="#f8fafb"
//             gradientWidth={100}
//             pauseOnHover={true}
//           >
//             {partners.map((partner, index) => (
//               <div key={index} className="partner-card">
//                 <img
//                   src={partner.icon}
//                   alt={partner.name}
//                   className="partner-icon"
//                 />
//                 <p className="partner-name">{partner.name}</p>
//               </div>
//             ))}
            
//             {/* Duplicate for seamless loop */}
//             {partners.map((partner, index) => (
//               <div key={`dup-${index}`} className="partner-card">
//                 <img
//                   src={partner.icon}
//                   alt={partner.name}
//                   className="partner-icon"
//                 />
//                 <p className="partner-name">{partner.name}</p>
//               </div>
//             ))}
//           </Marquee>
//         </div>
//       </section>

//       <WhyChooseUs />

//       <style jsx global>{`
//         @keyframes fade-in {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }

//         @keyframes slide-up {
//           from { transform: translateY(50px); opacity: 0; }
//           to { transform: translateY(0); opacity: 1; }
//         }

//         @keyframes card-pop {
//           from { transform: scale(0.8) rotateZ(-5deg); opacity: 0; }
//           to { transform: scale(1) rotateZ(0deg); opacity: 1; }
//         }

//         @keyframes blink {
//           0%, 100% { opacity: 1; }
//           50% { opacity: 0; }
//         }

//         .animate-fade-in {
//           animation: fade-in 0.8s ease-out forwards;
//         }

//         .animate-slide-up {
//           animation: slide-up 0.6s cubic-bezier(0.22, 1, 0.36, 1) forwards;
//         }

//         .animate-card-pop {
//           animation: card-pop 0.6s cubic-bezier(0.18, 0.89, 0.32, 1.28) forwards;
//         }

//         /* Marquee Styles */
//         .marquee-wrapper {
//           width: 100%;
//           overflow: hidden;
//           margin: 2rem 0;
//           padding: 1rem 0;
//         }

//         .react-fast-marquee {
//           display: flex;
//           align-items: center;
//         }

//         .partners-section {
//           padding: 4rem 2rem;
//           background: linear-gradient(160deg, #f8fafb 0%, #e2e8f0 100%);
//         }

//         .partners-title {
//           text-align: center;
//           font-size: 2.5rem;
//           font-weight: 700;
//           color: #024A59;
//           margin-bottom: 2rem;
//         }

//         .partner-card {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           margin: 0 2rem;
//           padding: 1.5rem;
//           background: white;
//           border-radius: 12px;
//           box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
//           transition: all 0.3s ease;
//           min-width: 180px;
//           height: 180px;
//         }

//         .partner-card:hover {
//           transform: translateY(-5px);
//           box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
//         }

//         .partner-icon {
//           width: 80px;
//           height: 80px;
//           object-fit: contain;
//           margin-bottom: 1rem;
//         }

//         .partner-name {
//           font-size: 1.1rem;
//           font-weight: 600;
//           color: #024A59;
//           text-align: center;
//           margin: 0;
//         }

//         /* Typing Effect Styles */
//         .Typewriter {
//           display: inline-block;
//         }

//         .Typewriter__cursor {
//           color: #FFA916;
//           font-weight: bold;
//           animation: blink 1s infinite;
//         }

//         /* Discover More Link Styles */
//         .discover-more {
//           background-color: #FFA916;
//           color: white;
//           padding: 0.8rem 2rem;
//           border-radius: 30px;
//           text-decoration: none;
//           font-weight: 600;
//           font-size: 1.1rem;
//           transition: all 0.3s ease;
//           border: 2px solid #FFA916;
//         }

//         .discover-more:hover {
//           background-color: transparent;
//           color: #FFA916;
//           transform: translateY(-3px);
//           box-shadow: 0 10px 20px rgba(255, 169, 22, 0.2);
//         }

//         .discover-text {
//           display: inline-block;
//           position: relative;
//         }

//         /* First Section Styles - UPDATED: Image on LEFT, Content on RIGHT */
//         .first-section {
//           position: relative;
//           min-height: 100vh;
//           display: flex;
//           align-items: center;
//           overflow: hidden;
//           background: linear-gradient(135deg, #024A59 0%, #012E39 100%);
//         }

//         .section-image {
//           position: absolute;
//           top: 0;
//           left: 0; /* Changed from right: 0 */
//           width: 50%;
//           height: 100%;
//           overflow: hidden;
//         }

//         .section-image img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           opacity: 0.8;
//         }

//         .section-content {
//           position: relative;
//           z-index: 2;
//           width: 50%;
//           margin-left: 50%; /* Push content to the right */
//           padding: 4rem;
//           color: white;
//         }

//         .content-wrapper h1 {
//           font-size: 3.5rem;
//           font-weight: 700;
//           margin-bottom: 1.5rem;
//           line-height: 1.2;
//           color: white;
//         }

//         .content-wrapper p {
//           font-size: 1.2rem;
//           margin-bottom: 2rem;
//           line-height: 1.6;
//           opacity: 0.9;
//         }

//         /* Products Section */
//         .products-section {
//           padding: 6rem 2rem;
//           background: #f8fafb;
//         }

//         .products-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
//           gap: 2rem;
//           max-width: 1200px;
//           margin: 0 auto;
//         }

//         .product-card {
//           transition: all 0.3s ease;
//           cursor: pointer;
//         }

//         .product-card:hover {
//           transform: translateY(-10px);
//           box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1) !important;
//         }

//         .product-title {
//           font-size: 1.5rem;
//           font-weight: 600;
//           margin: 1rem 0;
//           color: #024A59;
//         }

//         .product-description {
//           color: #4a5568;
//           line-height: 1.6;
//         }

//         @media (prefers-reduced-motion: reduce) {
//           .animate-fade-in,
//           .animate-slide-up,
//           .animate-card-pop,
//           .Typewriter__cursor,
//           .partner-card:hover,
//           .product-card:hover,
//           .discover-more:hover {
//             animation: none;
//             transition: none;
//           }
//         }

//         @media (max-width: 992px) {
//           .section-content {
//             width: 60%;
//             margin-left: 40%;
//             padding: 3rem;
//           }
          
//           .section-image {
//             width: 40%;
//           }
          
//           .content-wrapper h1 {
//             font-size: 2.8rem;
//           }
//         }

//         @media (max-width: 768px) {
//           .first-section {
//             flex-direction: column;
//           }
          
//           .section-image {
//             position: relative;
//             width: 100%;
//             height: 300px;
//             left: 0;
//             order: 1;
//           }
          
//           .section-content {
//             width: 100%;
//             margin-left: 0;
//             padding: 2rem;
//             order: 2;
//             text-align: center;
//           }
          
//           .content-wrapper h1 {
//             font-size: 2.2rem;
//             min-height: 90px;
//             justify-content: center;
//           }
          
//           .partner-card {
//             margin: 0 1rem;
//             min-width: 150px;
//             height: 150px;
//           }
          
//           .partner-icon {
//             width: 60px;
//             height: 60px;
//           }
          
//           .partners-title {
//             font-size: 2rem;
//           }
          
//           .products-grid {
//             grid-template-columns: 1fr;
//             padding: 0 1rem;
//           }
//         }

//         @media (max-width: 480px) {
//           .section-content {
//             padding: 1.5rem;
//           }
          
//           .content-wrapper h1 {
//             font-size: 1.8rem;
//             min-height: 80px;
//           }
          
//           .content-wrapper p {
//             font-size: 1rem;
//           }
          
//           .discover-more {
//             padding: 0.6rem 1.5rem;
//             font-size: 1rem;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default HomePage;



//second one 

import { Link } from 'react-router-dom';
import React, { useEffect, useState } from "react";
import '../css/home.css';
import {
  CheckCircle,
  Package, Users, Clock,
} from 'lucide-react';
import { useInView } from 'react-intersection-observer';
import CountUp from "react-countup";
import analysisImage from '../assests/images/analysis.jpg';
import NetworkIcon from '../assests/images/erp-infographic.jpg';
import ChartBarIcon from '../assests/images/data.jpg';
import LightbulbIcon from '../assests/images/Strategic.jpg';
import Code12 from "../assests/images/Code12.jpg";
import erpnextIcon from '../assests/images/Erpnext-icon.jpg';
import dynamicsNavIcon from '../assests/images/microsoft_dynamics_icon.png';
import azureIcon from '../assests/images/microsoft_azure_icon.png';
import powerBiIcon from '../assests/images/powerBI_icon.png';
import office365Icon from '../assests/images/office365_icon.png';
import businessCentralIcon from '../assests/images/business-central-icon.png';
import WhyChooseUs from "./WhyChooseUs";
import ServiceVisual from "../assests/images/carousel-1.jpg";

const HomePage = () => {
  // Typing effect states for heading
  const [headingText, setHeadingText] = useState('');
  const [headingIndex, setHeadingIndex] = useState(0);
  const [isHeadingTyping, setIsHeadingTyping] = useState(true);
  const [headingPhase, setHeadingPhase] = useState('typing'); // 'typing', 'waiting', 'erasing', 'waiting-after-erase'
  
  // Typing effect states for button
  const [buttonText, setButtonText] = useState('');
  const [buttonIndex, setButtonIndex] = useState(0);
  const [isButtonTyping, setIsButtonTyping] = useState(false);
  const [buttonPhase, setButtonPhase] = useState('waiting'); // 'typing', 'waiting', 'erasing', 'waiting-after-erase'
  
  const fullHeading = "Empowering Your Business with Tailored Digital Solutions";
  const fullButtonText = "Discover more";

  // Typing effect for heading - with repeating cycle
  useEffect(() => {
    let timeout;
    
    if (headingPhase === 'typing') {
      if (headingIndex < fullHeading.length) {
        timeout = setTimeout(() => {
          setHeadingText(prev => prev + fullHeading.charAt(headingIndex));
          setHeadingIndex(prev => prev + 1);
        }, 50);
      } else {
        // Finished typing, wait then start erasing
        timeout = setTimeout(() => {
          setHeadingPhase('waiting');
        }, 1500);
      }
    } else if (headingPhase === 'waiting') {
      // Wait for a bit, then start erasing
      timeout = setTimeout(() => {
        setHeadingPhase('erasing');
      }, 1000);
    } else if (headingPhase === 'erasing') {
      if (headingText.length > 0) {
        timeout = setTimeout(() => {
          setHeadingText(prev => prev.slice(0, -1));
        }, 30);
      } else {
        // Finished erasing, wait then start typing again
        setHeadingIndex(0);
        timeout = setTimeout(() => {
          setHeadingPhase('waiting-after-erase');
        }, 500);
      }
    } else if (headingPhase === 'waiting-after-erase') {
      // Wait for a bit, then start typing again
      timeout = setTimeout(() => {
        setHeadingPhase('typing');
        // Also trigger button typing after heading starts
        if (!isButtonTyping) {
          setButtonPhase('typing');
          setIsButtonTyping(true);
        }
      }, 800);
    }

    return () => clearTimeout(timeout);
  }, [headingPhase, headingIndex, headingText, isButtonTyping]);

  // Typing effect for button - with repeating cycle
  useEffect(() => {
    let timeout;
    
    if (buttonPhase === 'typing') {
      if (buttonIndex < fullButtonText.length) {
        timeout = setTimeout(() => {
          setButtonText(prev => prev + fullButtonText.charAt(buttonIndex));
          setButtonIndex(prev => prev + 1);
        }, 50);
      } else {
        // Finished typing, wait then start erasing
        timeout = setTimeout(() => {
          setButtonPhase('waiting');
        }, 1500);
      }
    } else if (buttonPhase === 'waiting') {
      // Wait for a bit, then start erasing
      timeout = setTimeout(() => {
        setButtonPhase('erasing');
      }, 1000);
    } else if (buttonPhase === 'erasing') {
      if (buttonText.length > 0) {
        timeout = setTimeout(() => {
          setButtonText(prev => prev.slice(0, -1));
        }, 30);
      } else {
        // Finished erasing, wait then start typing again
        setButtonIndex(0);
        timeout = setTimeout(() => {
          setButtonPhase('waiting-after-erase');
        }, 500);
      }
    } else if (buttonPhase === 'waiting-after-erase') {
      // Wait for a bit, then start typing again
      timeout = setTimeout(() => {
        setButtonPhase('typing');
      }, 1000);
    }

    return () => clearTimeout(timeout);
  }, [buttonPhase, buttonIndex, buttonText]);

  // Start the button typing after heading completes first cycle
  useEffect(() => {
    const timer = setTimeout(() => {
      if (headingPhase === 'waiting' && !isButtonTyping) {
        setButtonPhase('typing');
        setIsButtonTyping(true);
      }
    }, 3000); // Start button after heading is complete for first time
    
    return () => clearTimeout(timer);
  }, [headingPhase, isButtonTyping]);

  const services = [
    {
      icon: NetworkIcon,
      title: "Integrated ERP Solutions",
      text: "Our integrated ERP solutions are designed to streamline your business operations, from finance and human resources to supply chain management and customer relationship management. With our expertise in Microsoft ERP systems, we offer tailored solutions that meet your specific"
    },
    {
      icon: ChartBarIcon,
      title: "Data Analytics",
      text: "Harness the power of data with our advanced analytics and digital transformation services. We help you unlock actionable insights from your data assets, enabling data-driven decision-making and innovation. Our data analytics solutions encompass data collection, cleansing, modeling, and visualization"
    },
    {
      icon: LightbulbIcon,
      title: "Strategic Business Consultancy",
      text: "Our strategic business consultancy services are aimed at helping you navigate the complexities of the business landscape and make informed decisions that drive growth and profitability. Leveraging our expertise in project management, business analysis, and functional consultancy, we"
    },
  ];

  const [statsVisible, setStatsVisible] = useState(false);
  const { ref: statsRef, inView: statsInView } = useInView({ threshold: 0.3, triggerOnce: true });
  useEffect(() => {
    if (statsInView) setStatsVisible(true);
  }, [statsInView]);

  const products = [
    {
      icon: '💼',
      title: 'Microsoft Dynamics 365 Business Central',
      background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174) 100%)',
      description: 'An all-in-one platform offering integrated tools to efficiently manage finance, human resources, procurement, inventory, and daily operations—all in one centralized system.',
    },
    {
      icon: '📊',
      title: 'Analytics Dashboard',
      background: 'linear-gradient(135deg,rgb(201, 234, 241) 0%,rgb(132, 172, 180) 100%)',
      description: 'Interactive, real-time dashboards powered by Power BI and Azure, delivering deep insights, trends, and performance metrics to guide strategic decisions.',
    },
    {
      icon: '☁️',
      background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174) 100%)',
      title: 'Cloud Solutions',
      description: 'Effortlessly connect your operations to cloud services like Microsoft Azure and Office 365 to enable secure data access, remote collaboration, and scalability.',
    },
    {
      icon: '🧩',
      title: 'ERPNext',
      background: 'linear-gradient(135deg,rgb(201, 234, 241) 0%,rgb(132, 172, 180) 100%)',
      description: 'A highly customizable, open-source ERP platform offering end-to-end modules for accounting, sales, CRM, HR, inventory, and more—ideal for businesses of all sizes.',
    },
    {
      icon: '🛠️',
      title: 'Custom Software Solutions',
      background: 'linear-gradient(135deg,rgb(173, 161, 131) 0%,rgb(244, 219, 174) 100%)',
      description: 'Designed specifically for your business needs, these custom-built ERP modules enhance productivity by automating workflows and bridging process gaps.',
    },
    {
      icon: '🛒',
      title: 'POS',
      background: 'linear-gradient(135deg,rgb(201, 234, 241) 0%,rgb(132, 172, 180) 100%)',
      description: 'A fast, user-friendly Point of Sale system that syncs with your ERP in real time to manage sales, inventory, customer data, and transactions across multiple outlets.',
    },
  ];

  const partners = [
    { icon: erpnextIcon, name: 'ERPNext' },
    { icon: dynamicsNavIcon, name: 'Dynamics NAV' },
    { icon: businessCentralIcon, name: 'Business Central' },
    { icon: azureIcon, name: 'Azure' },
    { icon: powerBiIcon, name: 'Power BI' },
    { icon: office365Icon, name: 'Office 365' },
  ];

  // Duplicate partners for seamless marquee effect
  const marqueePartners = [...partners, ...partners, ...partners];
  const [isMarqueePaused, setIsMarqueePaused] = useState(false);

  return (
    <div style={{ overflow: 'hidden' }}>
      {/* Hero Section with repeated typing effects */}
      <section className="first-section">
        <div className="section-image">
          <img src={Code12} alt="Business Solutions Overview" />
        </div>

        <div className="section-content">
          <div className="content-wrapper">
            <h1 style={{ 
              minHeight: '4rem', 
              position: 'relative',
              overflow: 'hidden'
            }}>
              {headingText}
              <span 
                style={{
                  display: 'inline-block',
                  width: '3px',
                  height: '1.2em',
                  backgroundColor: '#FFA916',
                  marginLeft: '4px',
                  animation: (headingPhase === 'typing' || headingPhase === 'erasing') ? 'blink 1s infinite' : 'none',
                  verticalAlign: 'middle',
                  opacity: (headingPhase === 'typing' || headingPhase === 'erasing') ? 1 : 0
                }}
              />
            </h1>
            <p>
              We build smart, scalable systems—from ERP and custom software to document management and analytics—designed to streamline your operations and accelerate growth.
            </p>
            <Link 
              to="/contact" 
              className="discover-more" 
              style={{ 
                position: 'relative',
                minWidth: '140px',
                display: 'inline-block'
              }}
            >
              <span className="discover-text" style={{ position: 'relative' }}>
                {buttonText}
                <span 
                  style={{
                    display: 'inline-block',
                    width: '2px',
                    height: '1em',
                    backgroundColor: '#FFA916',
                    marginLeft: '4px',
                    animation: (buttonPhase === 'typing' || buttonPhase === 'erasing') ? 'blink 1s infinite' : 'none',
                    verticalAlign: 'middle',
                    opacity: (buttonPhase === 'typing' || buttonPhase === 'erasing') ? 1 : 0,
                    transition: 'opacity 0.3s ease'
                  }}
                />
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* Enhanced Services Section */}
      <section
        style={{
          padding: '10rem 0 0',
          background: 'linear-gradient(160deg, #f8fafb 0%, #e2e8f0 100%)',
          position: 'relative',
        }}
      >
        <div
          style={{
            maxWidth: '80%',
            margin: '0 auto',
            position: 'relative',
            zIndex: 2,
          }}
        >
          <div className="row g-4" style={{ marginBottom: 0 }}>
            {services.slice(0, 6).map((service, index) => (
              <div key={index} className="col-lg-4 col-md-6" style={{ marginBottom: '0' }}>
                <div
                  className="service-card move-up"
                  style={{
                    transform: 'translateY(-50%)',
                    marginBottom: '-11rem',
                  }}
                >
                  <div className="service-img-wrapper">
                    <img src={service.icon} alt={service.title} className="service-img" />
                  </div>
                  <div
                    className="service-content"
                    style={{
                      padding: '1.5rem',
                      backgroundColor: '#fff',
                    }}
                  >
                    <h5 style={{ marginBottom: '0.5rem' }}>{service.title}</h5>
                    <p className="text-muted">{service.text}</p>
                    <a
                      href="/services"
                      style={{
                        marginTop: '0.75rem',
                        display: 'inline-block',
                        color: '#FFA916',
                        fontWeight: '500',
                        textDecoration: 'none',
                      }}
                    >
                      → View Details
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section
        style={{
          position: 'relative',
          display: 'flex',
          padding: '4rem 2rem',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: '2rem',
          backgroundImage: `url(${ServiceVisual})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          color: 'white',
          overflow: 'hidden',
        }}
      >
        {/* Overlay with backgroundColor and blur */}
        <div
          style={{
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: '#024A59',
            opacity: 0.85,
            backdropFilter: 'blur(6px)', // blur effect
            WebkitBackdropFilter: 'blur(6px)',
            zIndex: 0,
          }}
        />

        {/* Left Column */}
        <div style={{ flex: 1, position: 'relative', zIndex: 1 }}>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#FFA916' }}>
            Company Overview
          </h2>
          <h3 style={{ fontSize: '1.5rem', fontWeight: '500', color: '#e2e8f0' }}>
            Innovating Business Excellence
          </h3>
        </div>

        {/* Right Column */}
        <div style={{ flex: 2, position: 'relative', zIndex: 1 }}>
          <p style={{ fontSize: '1.1rem', color: '#f8fafc', lineHeight: 1.7 }}>
            Statify Solutions Limited is a forward-thinking software company committed to
            innovation and excellence. Beyond ERP, we deliver a wide range of tailored
            digital solutions that drive transformation and growth for businesses globally.
            With a customer-first approach, we strive to exceed expectations and create
            lasting impact across industries.
          </p>
          <div
            style={{
              marginTop: '1rem',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <a
              href="/about"
              style={{
                color: '#FFA916',
                fontWeight: '500',
                textDecoration: 'none',
              }}
            >
              → More About Us
            </a>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="products-section">
        <h2 style={{ fontSize: '3rem', fontWeight: '700', color: '#024A59', marginBottom: '1rem' }}>
          <span style={{ color: '#024A59' }}>Our Products</span>
        </h2>
        <h5 style={{ textAlign: 'center', color: 'black', marginBottom: '2rem' }}>
          Empowering Enterprises Through Technology.
        </h5>
        <div className="products-grid">
          {products.map((product, index) => (
            <div
              className="product-card"
              key={index}
              style={{
                background: product.background,
                borderRadius: '15px',
                padding: '2rem',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
                transition: 'all 0.3s ease',
              }}
            >
              <div className="product-icon" style={{ fontSize: '40px' }}>
                {product.icon}
              </div>
              <h3 className="product-title">{product.title}</h3>
              <p className="product-description">{product.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Stats Section */}
      <section>
        <div
          ref={statsRef}
          style={{
            backgroundImage: `url(${analysisImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            padding: '2rem 1rem',
            color: 'white',
            position: 'relative',
          }}
        >
          {/* Optional overlay for better readability */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(2, 74, 89, 0.85)',
            zIndex: 0,
          }} />

          <h5 style={{
            textAlign: 'center',
            color: 'white',
            marginBottom: '2rem',
            position: 'relative',
            zIndex: 1
          }}>
            Empowering your business to reach new heights.
          </h5>

          <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '2rem',
              textAlign: 'center'
            }}>
              {[
                { number: 13, title: "Products", icon: <Package size={40} color="#FFA916" /> },
                { number: 19, title: "Services", icon: <CheckCircle size={40} color="#FFA916" /> },
                { number: 31, title: "Satisfied Clients", icon: <Users size={40} color="#FFA916" /> },
                { number: 8, title: "Ongoing Projects", icon: <Clock size={40} color="#FFA916" /> }
              ].map((stat, index) => (
                <div key={index} style={{
                  opacity: statsVisible ? 1 : 0,
                  transform: statsVisible ? 'translateY(0)' : 'translateY(30px)',
                  transition: `all 0.6s ease ${index * 0.2}s`,
                  background: 'rgba(255, 255, 255, 0.15)',
                  borderRadius: '16px',
                  padding: '2rem',
                  backdropFilter: 'blur(6px)',
                }}>
                  <div style={{
                    background: 'rgba(255, 169, 22, 0.1)',
                    width: '70px',
                    height: '70px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 1rem'
                  }}>
                    {stat.icon}
                  </div>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#FFA916', marginBottom: '0.5rem' }}>
                    {statsVisible ? <CountUp end={stat.number} duration={2.5} /> : stat.number}
                    {stat.title === 'Products' && '+'}
                    {['Services'].includes(stat.title) && '+'}
                    {['Satisfied Clients'].includes(stat.title) && '+'}
                  </h2>
                  <p style={{ fontSize: '1.1rem', margin: 0 }}>{stat.title}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Marquee Partners Section */}
      <section 
        className="partners-section"
        style={{
          padding: '4rem 0',
          backgroundColor: '#f8fafb',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <h2 className="partners-title" style={{
          textAlign: 'center',
          fontSize: '2.5rem',
          fontWeight: '700',
          color: '#024A59',
          marginBottom: '2rem'
        }}>
          Our Partners/Technologies
        </h2>
        <div 
          className="partners-marquee-container"
          onMouseEnter={() => setIsMarqueePaused(true)}
          onMouseLeave={() => setIsMarqueePaused(false)}
          style={{
            position: 'relative',
            overflow: 'hidden',
            width: '100%',
            padding: '1rem 0',
          }}
        >
          <div 
            className="marquee-track"
            style={{
              display: 'flex',
              animation: isMarqueePaused ? 'none' : 'marqueeScroll 40s linear infinite',
              width: 'fit-content',
            }}
          >
            {marqueePartners.map((partner, index) => (
              <div 
                key={index} 
                className="partner-card-marquee"
                style={{
                  flex: '0 0 auto',
                  margin: '0 2rem',
                  textAlign: 'center',
                  minWidth: '180px',
                  transition: 'all 0.3s ease',
                  transform: isMarqueePaused ? 'scale(1.05)' : 'scale(1)',
                }}
              >
                <div style={{
                  background: 'white',
                  borderRadius: '16px',
                  padding: '2rem',
                  boxShadow: '0 8px 30px rgba(0, 0, 0, 0.08)',
                  marginBottom: '1rem',
                  transition: 'all 0.3s ease',
                  height: '140px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid rgba(2, 74, 89, 0.1)',
                }}>
                  <img
                    src={partner.icon}
                    alt={partner.name}
                    style={{
                      maxWidth: '120px',
                      maxHeight: '80px',
                      objectFit: 'contain',
                      filter: isMarqueePaused ? 'grayscale(0) brightness(1)' : 'grayscale(0.3) brightness(1.1)',
                      transition: 'all 0.3s ease',
                    }}
                  />
                </div>
                <p style={{
                  fontWeight: '600',
                  color: '#024A59',
                  margin: 0,
                  fontSize: '1rem',
                  transition: 'color 0.3s ease',
                  color: isMarqueePaused ? '#FFA916' : '#024A59',
                }}>
                  {partner.name}
                </p>
              </div>
            ))}
          </div>
          
          {/* Gradient overlays for fade effect */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '150px',
            height: '100%',
            background: 'linear-gradient(to right, #f8fafb, transparent)',
            zIndex: 2,
            pointerEvents: 'none',
          }} />
          <div style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '150px',
            height: '100%',
            background: 'linear-gradient(to left, #f8fafb, transparent)',
            zIndex: 2,
            pointerEvents: 'none',
          }} />
        </div>
      </section>

      <WhyChooseUs />

      <style jsx global>{`
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes slide-up {
          from { transform: translateY(50px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }

        @keyframes card-pop {
          from { transform: scale(0.8) rotateZ(-5deg); opacity: 0; }
          to { transform: scale(1) rotateZ(0deg); opacity: 1; }
        }

        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }

        @keyframes marqueeScroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(calc(-180px * ${partners.length} * 1.5));
          }
        }

        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.05); }
          100% { transform: scale(1); }
        }

        .animate-fade-in {
          animation: fade-in 0.8s ease-out forwards;
        }

        .animate-slide-up {
          animation: slide-up 0.6s cubic-bezier(0.22, 1, 0.36, 1) forwards;
        }

        .animate-card-pop {
          animation: card-pop 0.6s cubic-bezier(0.18, 0.89, 0.32, 1.28) forwards;
        }

        .discover-more {
          position: relative;
          display: inline-block;
          overflow: hidden;
          background-color: #FFA916;
          color: white;
          padding: 12px 28px;
          border-radius: 30px;
          font-weight: 600;
          text-decoration: none;
          transition: all 0.3s ease;
          border: 2px solid #FFA916;
        }

        .discover-more:hover {
          background-color: transparent;
          color: #FFA916;
          animation: pulse 1s infinite;
        }

        .discover-text {
          display: inline-block;
          position: relative;
          font-size: 1.1rem;
          letter-spacing: 0.5px;
        }

        /* Typing cursor styles */
        .typing-cursor {
          display: inline-block;
          width: 3px;
          height: 1.2em;
          background-color: #FFA916;
          margin-left: 4px;
          animation: blink 1s infinite;
          vertical-align: middle;
        }

        /* Responsive adjustments for marquee */
        @media (max-width: 768px) {
          .marquee-track {
            animation-duration: 30s !important;
          }
          
          .partner-card-marquee {
            margin: 0 1rem !important;
            min-width: 140px !important;
          }
          
          .partner-card-marquee img {
            max-width: 100px !important;
            max-height: 60px !important;
          }
          
          .partners-title {
            font-size: 2rem !important;
          }
        }

        @media (max-width: 480px) {
          .marquee-track {
            animation-duration: 25s !important;
          }
          
          .partner-card-marquee {
            margin: 0 0.8rem !important;
            min-width: 120px !important;
          }
          
          .partner-card-marquee img {
            max-width: 80px !important;
            max-height: 50px !important;
          }
          
          .discover-more {
            padding: 10px 24px;
            font-size: 0.95rem;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .animate-fade-in,
          .animate-slide-up,
          .animate-card-pop,
          .marquee-track,
          .discover-more:hover {
            animation: none;
          }
          
          .typing-cursor,
          .discover-text::after {
            display: none;
          }
        }

        /* Ensure consistent spacing for typing area */
        h1 {
          white-space: normal;
          word-wrap: break-word;
          line-height: 1.2;
        }
      `}</style>
    </div>
  );
};

export default HomePage;